export function authenticationHeader() {
    return {
        restrict: 'E',
        bindToController: {
            locationKey: '@locationKey'
        },
        scope: {},
        controller: AuthenticationHeaderController,
        controllerAs: 'vm',
        templateUrl: 'app/components/authentication-header.directive.html'
    };
}

class AuthenticationHeaderController {
    /* @ngInject */
    constructor(destinationService, $window, egUrlService, $http, authenticatedUserService, errorService,
                accessRightService, $stateParams
    ) {
        this.$window = $window;
        this.egUrlService = egUrlService;
        this.$http = $http;
        this.state = $stateParams.state;
        this.authenticatedUserService = authenticatedUserService;
        this.user = {};
        authenticatedUserService.getAuthenticatedUsers()
            .then(response => { this.user = response[0]; });

        destinationService.getDestinationInstallation()
            .then(response => { this.destinationInstallation = response; });

        destinationService.getDestinationSecurityContext()
            .then(response => { this.destinationSecurityContext = response; });

        this.errorMessageKey = errorService.getErrorMessageKey();
        accessRightService.hasAnyAccess(['EGTO_AUTHENTICATION_SERVICE_ADMIN']).then(response => {
            this.isAdmin = response;
        });
        accessRightService.hasAnyAccess(['ORGANIZATION_ADMIN', 'EGTO_SUPER_ADMIN_LOGIN']).then(response => {
                this.mayEditUsers = response;
        });
    }

    operationStatus() {
        var url = this.egUrlService.url('/authentication/operationStatus');
        this.$http.get(url)
              .then(response => {
                  this.$window.open(response.data);});
    }
}
